export const ALL_RULES_LIST_SET = 'ALL_RULES_LIST_SET'
export const RULES_LIST_SET = 'RULES_LIST_SET'
export const RULES_LIST_REQ = 'RULES_LIST_REQ'
export const RULES_LIST_SUCCESS = 'RULES_LIST_SUCCESS'
export const RULES_LIST_ERROR = 'RULES_LIST_ERROR'
export const RULES_LIST_RESET_STATUS = 'RULES_LIST_RESET_STATUS'
export const PRVILEGED_RULES_LIST_SET = 'PRVILEGED_RULES_LIST_SET'
export const MASTER_RULESET_UPLOAD = 'MASTER_RULESET_UPLOAD'
export const MASTER_RULESET_UPLOAD_SUCCESS = 'MASTER_RULESET_UPLOAD_SUCCESS'
export const MASTER_RULESET_UPLOAD_ERROR = 'MASTER_RULESET_UPLOAD_ERROR'
export const OVERRIDE_RULESET_UPLOAD = 'OVERRIDE_RULESET_UPLOAD'
export const OVERRIDE_RULESET_UPLOAD_SUCCESS = 'OVERRIDE_RULESET_UPLOAD_SUCCESS'
export const OVERRIDE_RULESET_UPLOAD_ERROR = 'OVERRIDE_RULESET_UPLOAD_ERROR'
export const RULES_REVISIONS_LIST_REQ = 'RULES_REVISIONS_LIST_REQ'
export const RULES_REVISIONS_LIST_SUCCESS = 'RULES_REVISIONS_LIST_SUCCESS'
export const RULES_REVISIONS_LIST_ERROR = 'RULES_REVISIONS_LIST_ERROR'
export const ALLOW_RULES_OVERRIDE = 'ALLOW_RULES_OVERRIDE'
export const RULES_WHITELIST_REQ = 'RULES_WHITELIST_REQ'
export const RULES_WHITELIST_SET = 'RULES_WHITELIST_SET'
export const RULES_WHITELIST_REQ_SUCCESS = 'RULES_WHITELIST_REQ_SUCCESS'
export const RULES_WHITELIST_REQ_ERROR = 'RULES_WHITELIST_REQ_ERROR'
export const RULES_WHITELIST_CREATE_REQ = 'RULES_WHITELIST_CREATE_REQ'
export const RULES_WHITELIST_CREATE_REQ_SUCCESS = 'RULES_WHITELIST_CREATE_REQ_SUCCESS'
export const RULES_WHITELIST_CREATE_REQ_ERROR = 'RULES_WHITELIST_CREATE_REQ_ERROR'
export const RULES_WHITELIST_DELETE_REQ = 'RULES_WHITELIST_DELETE_REQ'
export const RULES_WHITELIST_DELETE_REQ_SUCCESS = 'RULES_WHITELIST_DELETE_REQ_SUCCESS'
export const RULES_WHITELIST_DELETE_REQ_ERROR = 'RULES_WHITELIST_DELETE_REQ_ERROR'
export const ALLOWLIST_REQ = 'ALLOWLIST_REQ'
export const ALLOWLIST_SET = 'ALLOWLIST_SET'
export const ALLOWLIST_REQ_SUCCESS = 'ALLOWLIST_REQ_SUCCESS'
export const ALLOWLIST_REQ_ERROR = 'ALLOWLIST_REQ_ERROR'
export const ALLOWLIST_CREATE_REQ = 'ALLOWLIST_CREATE_REQ'
export const ALLOWLIST_CREATE_REQ_SUCCESS = 'ALLOWLIST_CREATE_REQ_SUCCESS'
export const ALLOWLIST_CREATE_REQ_ERROR = 'ALLOWLIST_CREATE_REQ_ERROR'
export const ALLOWLIST_UPDATE_REQ = 'ALLOWLIST_UPDATE_REQ'
export const ALLOWLIST_UPDATE_REQ_SUCCESS = 'ALLOWLIST_UPDATE_REQ_SUCCESS'
export const ALLOWLIST_UPDATE_REQ_ERROR = 'ALLOWLIST_UPDATE_REQ_ERROR'
export const ALLOWLIST_DELETE_REQ = 'ALLOWLIST_DELETE_REQ'
export const ALLOWLIST_DELETE_REQ_SUCCESS = 'ALLOWLIST_DELETE_REQ_SUCCESS'
export const ALLOWLIST_DELETE_REQ_ERROR = 'ALLOWLIST_DELETE_REQ_ERROR'
export const ALLOWLIST_DETECTION_SET = 'ALLOWLIST_DETECTION_SET'
export const ALLOWLIST_EDIT_COPY_SET = 'ALLOWLIST_EDIT_COPY_SET'
export const ALLOWLIST_EDIT_SET = 'ALLOWLIST_EDIT_SET'

export const THREAT_PROGRESSION_VIEW_PREFERENCES_REQ = 'THREAT_PROGRESSION_VIEW_PREFERENCES_REQ'
export const SAVE_THREAT_PROGRESSION_VIEW_PREFERENCES = 'SAVE_THREAT_PROGRESSION_VIEW_PREFERENCES'

export const PRIVILEGED_ACTIVITIES_PREFERENCES_VIEW_REQ = 'PRIVILEGED_ACTIVITIES_PREFERENCES_VIEW_REQ'
export const SAVE_PRIVILEGED_ACTIVITIES_VIEW_PREFERENCES = 'SAVE_PRIVILEGED_ACTIVITIES_VIEW_PREFERENCES'

export const ALLOWLIST_VIEW_PREFERENCES_REQ = 'ALLOWLIST_VIEW_PREFERENCES_REQ'
export const SAVE_ALLOWLIST_VIEW_PREFERENCES = 'SAVE_ALLOWLIST_VIEW_PREFERENCES'



// WEBPACK FOOTER //
// ./src/store/modules/rules/rules.type.js